module.exports = __webpack_public_path__ + "img/ibank.45dd2098.svg";